import React, { PropsWithChildren } from 'react'
import { AppErrorHandling as Base } from 'src/error/AppErrorHandling'

const AnyBase = Base as unknown as React.ComponentType<any>

export const WithErrorHandling: React.FC<PropsWithChildren> = ({
    children
}) => <AnyBase>{children}</AnyBase>
